import React from "react";

import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons/faCircleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { defineMessages, useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { Popconfirm } from "@mapmycustomers/ui";

import Path from "@app/enum/Path";

import styles from "./EntityListModal.module.scss";

const messages = defineMessages({
  confirm: {
    id: "reports.overview.grossMetric.downloadWithWarning.confirm",
    defaultMessage: `Quick exports with more than 10,000 are not supported.<br>Only the first 10k rows will be included in your .csv export.<br>
<br>
To export more than 10k rows, go to Reports > <link>Exports</link>`,
    description: "Download confirm on the list modal for Overview Screen in Reports",
  },
  no: {
    id: "reports.overview.grossMetric.downloadWithWarning.no",
    defaultMessage: "Cancel",
    description: "Download Cancel button on the list modal for Overview Screen in Reports",
  },
  yes: {
    id: "reports.overview.grossMetric.downloadWithWarning.yes",
    defaultMessage: "Download anyway",
    description: "Download Confirm button on the list modal for Overview Screen in Reports",
  },
});

interface Props {
  onConfirm: () => void;
}

export const DownloadWarning: React.FC<Props> = ({ children, onConfirm }) => {
  const intl = useIntl();

  return (
    <Popconfirm
      cancelText={intl.formatMessage(messages.no)}
      description={intl.formatMessage(messages.confirm, {
        br: () => <br />,
        link: (text) => <Link to={`${Path.REPORTS}/exports`}>{text}</Link>,
      })}
      icon={<FontAwesomeIcon className={styles.downloadWarningIcon} icon={faCircleExclamation} />}
      okText={intl.formatMessage(messages.yes)}
      onConfirm={onConfirm}
      placement="topRight"
    >
      {children}
    </Popconfirm>
  );
};
